import React from 'react'
import AppZoo from '../components/AppZoo/AppZoo'

const AppZooPage = () => {
  return (
    <div>
      <AppZoo/>
    </div>
  )
}

export default AppZooPage